import HttpRequest from 'helper-xhr';

import { isProcessing } from "./processingActions.js";

import { ACTN_REFRESH } from "./action-types.js";

const _doSomething = (url, payload, method, getState) => {
  return dispatch => {

    var state = getState();

    var headers = [];
    if (state.pusher && state.pusher.socket_id) {
      headers.push({ header: "pusher-socket_id", value: state.pusher.socket_id });
    }

    dispatch(isProcessing({
      key: url,
      isProcessing: true
    }));

    var contentType = "application/json";
    if (payload instanceof FormData) {
      contentType = undefined;
      //contentType = "multipart/form-data";
    }

    method = method == "GET" ? method : "POST";

    var xhr = new HttpRequest(method, url.toLowerCase(), contentType, headers);
    return xhr.send(payload).then((response) => {
      var json = response.json;
      if (json.message || json.exception) {
        alert(json.message || json.exception);
      } else {
      }
      dispatch({
        type: ACTN_REFRESH,
        data: json
      });

      dispatch(isProcessing({
        key: url,
        isProcessing: false
      }));

      return json;
    }, (e) => {

      // recuperare la isProcessing dal progetto gommeCore

      dispatch(isProcessing({
        key: url,
        isProcessing: false
      }));
      return { error: e };
    });
  }
}

export const doSomething = (url, payload, method) => (dispatch, getState) => {
  return dispatch(_doSomething(url, payload, method, getState))
}
